import { ActionCreator, AjaxDispatcher } from "./ajax-dispatcher";
import Collapsable from "./collapsable";
import {
    addEventListenerIfNotExists,
    disable,
    enable,
    getBaseUrl,
    getCurrentLanguageId,
    getApiUrl,
    openComponentInPopup,
    setReadonly, unsetReadonly
} from "./common";
import Form from "./form";
import HttpClient from "./http-client";
import { initCustomerDataForm } from "./main";
import { PopupOptions, PopupWidth } from "./popup";
import $ from "jquery";
import '@selectize/selectize';

export default class CustomerDataForm {
    private readonly form: HTMLFormElement;
    private collapsable: Collapsable;
    private componentBaseElement: HTMLElement;
    private activeRegion: string;
    private activeRegionCountryId: string;
    private deliveryAddressCheckbox: HTMLInputElement;

    private countrySelectize: Selectize.IApi<any, any>;
    private countryDeliverySelectize: Selectize.IApi<any, any>;

    private regionInput: HTMLInputElement;
    private regionDeliveryInput: HTMLInputElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
        addEventListenerIfNotExists(this.form, 'submit', (evt) => this.processForm(evt));
        this.initCountrySelectors();
        this.initDeliveryAddress();
        this.initDeliveryRegion();
        this.initRegisterChoiceButtons();
    }

    private initRegisterChoiceButtons() {
        const showLoginButtonId = 'show-login';
        const continueCreteAccountButtonId = 'continue-create-account';
        const continueNotRegisteredButtonId = 'continue-not-register';

        var showLoginButton = this.form.querySelector(`#${showLoginButtonId}`) as HTMLElement;
        var continueCreteAccountButton = this.form.querySelector(`#${continueCreteAccountButtonId}`) as HTMLElement;
        var continueNotRegisteredButton = this.form.querySelector(`#${continueNotRegisteredButtonId}`) as HTMLElement;

        if (showLoginButton) {
            addEventListenerIfNotExists(showLoginButton, 'click', async () => await openComponentInPopup('LoginBox', null, <PopupOptions>{ width: PopupWidth.Mini }));
        }

        if (continueCreteAccountButton) {
            addEventListenerIfNotExists(continueCreteAccountButton, 'click', async () => await this.showForm(CartRegistrationMethod.WithRegistration));
        }
        if (continueNotRegisteredButton) {
            addEventListenerIfNotExists(continueNotRegisteredButton, 'click', async () => await this.showForm(CartRegistrationMethod.WithoutRegistration));
        }
    }

    private initDeliveryAddress() {
        const checkBoxId = 'delivery-address-switch';
        const areaId = 'delivery-address';
        this.deliveryAddressCheckbox = this.form.querySelector(`#${checkBoxId}`);
        const area = this.form.querySelector(`#${areaId}`);
        this.deliveryAddressCheckbox && area && (this.collapsable = new Collapsable(checkBoxId, areaId));
        this.deliveryAddressCheckbox && addEventListenerIfNotExists(this.deliveryAddressCheckbox, 'change', () => this.updateFormUsingRegion());
    }

    async showForm(registrationMethod: CartRegistrationMethod) {
        await this.saveWithRegistrationToCart(registrationMethod);
        this.reloadComponent();
    }

    private setAttribute(elementId: string, attributeName: string, isActive: boolean) {
        const element = this.form.querySelector(`#${elementId}`);
        if (element) {
            if (isActive) {
                element.setAttribute(attributeName, "");
            }
            else {
                element.removeAttribute(attributeName);
            }
        }
    }

    async saveWithRegistrationToCart(registrationMethod: CartRegistrationMethod) {
        const client = new HttpClient();
        const url = `${getApiUrl()}/cart/set-registration-method/${registrationMethod}`;

        const response = await client.fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json;',
                'Current-Language-Id': getCurrentLanguageId()
            }
        });
    }

    processForm(event: Event): void {
        const url = `${getBaseUrl()}orders`;
        const form = new Form(url, this.form, null, (html: string) => {
            document.querySelector(
                '#customer-form'
            ).innerHTML = html;

            this.collapsable && this.collapsable.refreshCollapsable();
            this.initCountrySelectors();
            this.initDeliveryAddress();
            this.initDeliveryRegion();
            this.initRegisterChoiceButtons();
        });
        form.process(event);
    }

    private initDeliveryRegion() {
        this.componentBaseElement = document.querySelector('[data-component="CustomerDataForm"]');
        this.activeRegion = this.componentBaseElement.dataset.region;
        this.activeRegionCountryId = this.componentBaseElement.dataset.countryId;

        this.regionInput = this.form.querySelector('input#Region') as HTMLInputElement;
        this.regionDeliveryInput = this.form.querySelector('input#RegionDelivery') as HTMLInputElement;

        this.updateFormUsingRegion();

    }

    private updateFormUsingRegion() {

        if (this.regionDeliveryInput && this.activeRegion) {
            setReadonly(this.regionDeliveryInput);
            this.regionDeliveryInput.value = this.activeRegion;
        }

        if (this.activeRegionCountryId) {
            this.countryDeliverySelectize && this.countryDeliverySelectize.disable();
            this.countryDeliverySelectize && this.countryDeliverySelectize.setValue(this.activeRegionCountryId);
        }

        if (this.deliveryAddressCheckbox && this.deliveryAddressCheckbox.checked) {
            this.countrySelectize && this.countrySelectize.enable();
            unsetReadonly(this.regionInput);
        }
        else {

            if (this.regionInput && this.activeRegion) {
                setReadonly(this.regionInput)
                this.regionInput.value = this.activeRegion;
            }

            this.countrySelectize && this.activeRegionCountryId && this.countrySelectize.disable();
            if (this.activeRegionCountryId && this.countrySelectize) {
                this.countrySelectize.disable();
                this.countrySelectize.setValue(this.activeRegionCountryId);
            }
        }
    }

    private initCountrySelectors() {
        this.countrySelectize = this.initSelector(this.form.querySelector('select#Country') as HTMLSelectElement);
        this.countryDeliverySelectize = this.initSelector(this.form.querySelector('select#CountryDelivery') as HTMLSelectElement);
    }

    private initSelector = (selectElement: HTMLSelectElement): Selectize.IApi<any, any> => {
        return (selectElement && $(selectElement))
            ? $(selectElement).selectize({
                sortField: 'text'
            })[0].selectize
            : null;
    }

    private reloadComponent(): void {
        const action = new ActionCreator().reloadComponent('CustomerDataForm');
        action.successAction = () => initCustomerDataForm();
        new AjaxDispatcher().dispatchGetAction(action);
    }
}

enum CartRegistrationMethod {
    Unset = 0,
    Login = 1,
    WithRegistration = 2,
    WithoutRegistration = 3
}
